export default function singleProductDisableSubmit() {
  const submit = document.querySelector(
    ".summary__add-to-cart .single_add_to_cart_button"
  );
  // console.log(submit);
  const select_all = document.querySelectorAll(
    ".summary__add-to-cart .wccpf-field"
  );
  let is_first_time = true;
  console.log(select_all, "select_all");
  const select_count = select_all.length;
  // console.log(select_count, 'select_count');

  function selectHandler() {
    const result = [];
    select_all.forEach((select) => {
      const value = select.value;

      const options = Array.from(select.querySelectorAll("option"));
      const values = options.map((item) => {
        return item.value;
      });
      // console.log(values);
      const is_first_elem = values[0] === value;
      // console.log(is_first_elem);
      result.push(is_first_elem);
    });
    // console.log(result);
    const false_array = result.filter((item) => item === false);
    console.log(false_array.length);
    return false_array.length === 2;
  }

  function disableButton() {
    submit.setAttribute("disabled", true);
  }
  function enableButton() {
    submit.removeAttribute("disabled");
  }

  function submitToggle() {
    // console.log(selectHandler());
    if (selectHandler()) {
      enableButton();
    } else {
      disableButton();
    }
  }
  submitToggle();
  function singleSelectHandler() {
    const select = select_all[0];
    console.log(select, "select");
    console.log(select.value);
    select.addEventListener("change", function () {
      const value = select.value;
      const options = Array.from(select.querySelectorAll("option"));
      const values = options.map((item) => {
        return item.value;
      });
      // console.log(values);
      const is_first_elem = values[0] === value;
      return is_first_elem;
    });
  }
  console.log(select_count, "select_count");
  if (select_count > 1) {
    select_all.forEach((select) => {
      select.addEventListener("change", function () {
        // console.log(select.value);
        submitToggle();
      });
    });
  } else {
    // console.log( 'select ')
    // console.log(singleSelectHandler(), "singleSelectHandler()");
    const select = select_all[0];
    console.log(select, "select");
    console.log(select.value);
    select.addEventListener("change", function () {
      const value = select.value;
      const options = Array.from(select.querySelectorAll("option"));
      const values = options.map((item) => {
        return item.value;
      });
      // console.log(values);
      const is_first_elem = values[0] === value;
      if (is_first_elem) {
        disableButton();
      }else{
        enableButton();
      }
    });
  }
  // console.log(selectHandler());
}
